import React, { useState } from 'react';
import { Check, X } from 'lucide-react';
import { Dropdown, Button } from '@grofers/dock-design-kit';

/**
 * Standalone screen shown once step 4 resolves - either `/resolve`
 * succeeding, or a service-denial "Proceed" (see CopilotView.js), which
 * never calls `/resolve` at all. `isServiceDenied` swaps the success
 * checkmark for a red X and is also the only case with any further action
 * here - "Add Tags" plus "Close Chat" to submit them (`add_manual_tag`,
 * via `onCloseChat`) before closing the panel. A normal resolution has
 * nothing left to do on this screen; the panel's own header close (X)
 * handles dismissing it.
 */
const ResolutionConfirmation = ({
  title = 'Resolution Initiated',
  tagOptions = [],
  isServiceDenied = false,
  onCloseChat = () => {},
}) => {
  const [addedTagSlugs, setAddedTagSlugs] = useState([]);

  return (
    <div className='tw-flex tw-flex-col tw-gap-[20px] tw-w-full tw-h-full'>
      <div className='tw-flex-1 tw-flex tw-flex-col tw-items-center tw-gap-[20px] tw-justify-center'>
        <div
          className={`tw-flex tw-items-center tw-justify-center tw-size-[72px] tw-rounded-full ${
            isServiceDenied ? 'tw-bg-red-500' : 'tw-bg-base-green'
          }`}
        >
          {isServiceDenied ? (
            <X size={48} className='tw-text-white' />
          ) : (
            <Check size={48} className='tw-text-white' />
          )}
        </div>
        <p className='tw-text-[24px] tw-leading-[30px] tw-font-semibold tw-text-grey-900 tw-m-0'>
          {title}
        </p>

        {isServiceDenied && (
          <div className='tw-flex tw-flex-col tw-gap-[16px] tw-w-full'>
            <div className='tw-flex tw-flex-col tw-gap-[6px] tw-w-full'>
              <p className='tw-text-[14px] tw-leading-[18px] tw-font-medium tw-text-[#384250] tw-m-0'>
                Add Tags
              </p>
              <Dropdown
                placeholder='Search and add more'
                size='md'
                state='default'
                type='multiple'
                items={tagOptions}
                value={addedTagSlugs}
                onChange={setAddedTagSlugs}
                fullWidth
              />
            </div>
          </div>
        )}
      </div>

      {isServiceDenied && (
        <div className='tw-flex tw-flex-col tw-w-full tw-mb-4'>
          <Button
            variant='primary'
            buttonType='default'
            size='lg'
            shape='square'
            fullWidth
            disabled={addedTagSlugs.length === 0}
            onClick={() => onCloseChat(addedTagSlugs)}
            className={addedTagSlugs.length > 0 ? '!tw-bg-base-green' : ''}
          >
            Close Chat
          </Button>
        </div>
      )}
    </div>
  );
};

export default ResolutionConfirmation;
